const news = [
  {
    path: '/article-detail',
    name: 'article-detail',
    component: () => import(/* webpackChunkName: "article-detail" */ '@/pages/article/article-detail.vue'),
    meta: {
      titleBar: {
        title: '健康资讯',
        hasMenu: true
      }
    }
  },
  {
    path: '/article-list',
    name: 'article-list',
    component: () => import(/* webpackChunkName: "article-list" */ '@/pages/article/article-list.vue'),
    meta: {
      titleBar: {
        title: '健康资讯',
        hasMenu: true
      },
      keepAlive: []
    }
  },
  {
    path: '/video-list',
    name: 'video-list',
    component: () => import(/* webpackChunkName: "videos" */ '@/pages/video/video-list.vue'),
    meta: {
      titleBar: {
        title: '科普视频',
        hasMenu: true
      },
      keepAlive: []
    }
  },
  {
    path: '/video-detail',
    name: 'video-detail',
    component: () => import(/* webpackChunkName: "video-detail" */ '@/pages/video/video-detail.vue'),
    meta: {
      titleBar: {
        title: '视频详情',
        hasMenu: true
      }
    }
  },
  {
    path: '/question-list',
    name: 'question-list',
    component: () => import(/* webpackChunkName: "question-list" */ '@/pages/question/question-list.vue'),
    meta: {
      titleBar: {
        title: '健康问答',
        hasMenu: true
      }
    }
  },
  {
    path: '/question-detail',
    name: 'question-detail',
    component: () => import(/* webpackChunkName: "question-detail" */ '@/pages/question/question-detail.vue'),
    meta: {
      titleBar: {
        title: '问答详情',
        hasMenu: true
      }
    }
  },
  {
    path: '/topic',
    name: 'topic',
    component: () => import(/* webpackChunkName: "topic" */ '@/pages/topic/index.vue'),
    meta: {
      login: true
    }
  },
  {
    path: '/ill',
    name: 'ill',
    component: () => import(/* webpackChunkName: "ill" */ '@/pages/ill-drug/ill.vue'),
    meta: {
      titleBar: {
        title: '疾病百科',
        hasMenu: true
      }
    }
  },
  {
    path: '/ill-search',
    name: 'ill-search',
    component: () => import(/* webpackChunkName: "ill-search" */ '@/pages/ill-drug/illSearch.vue'),
    meta: {
      titleBar: {
        title: '疾病百科',
        hasMenu: true
      }
    }
  },
  {
    path: '/drug-search',
    name: 'drug-search',
    component: () => import(/* webpackChunkName: "drug-search" */ '@/pages/ill-drug/drugSearch.vue'),
    meta: {
      titleBar: {
        title: '药品百科',
        hasMenu: true
      }
    }
  },
  // 药品百科详情,同时带id
  {
    path: '/drug-detail/:id',
    name: 'drug-detail',
    component: () => import(/* webpackChunkName: "drug-detail" */ '@/pages/ill-drug/children/drug-detail.vue'),
    meta: {
      titleBar: {
        title: '药品百科',
        hasMenu: true
      }
    }
  },
  // 疾病详情,同时带id
  {
    path: '/ill-detail/:id',
    name: 'ill-detail',
    component: () => import(/* webpackChunkName: "ill-detail" */ '@/pages/ill-drug/children/ill-detail.vue'),
    meta: {
      titleBar: {
        title: '疾病百科',
        hasMenu: true
      }
    }
  },
  {
    path: '/chinese-medicine',
    name: 'chinese-medicine',
    component: () => import(/* webpackChunkName: "chinese-medicine-index" */ '@/pages/chinese-medicine/index.vue'),
    redirect: '/chinese-medicine/list',
    children: [{
      path: 'list',
      name: 'chinese-medicine-list',
      component: () => import(/* webpackChunkName: "chinese-medicine" */ '@/pages/chinese-medicine/list.vue'),
      meta: {
        title: '中医医典',
        titleBar: {
          title: '中医医典',
          hasMenu: true
        }
      }
    },
    {
      path: 'detail',
      name: 'chinese-medicine-detail',
      component: () => import(/* webpackChunkName: "chinese-medicine-detail" */ '@/pages/chinese-medicine/detail.vue'),
      meta: {
        title: '中医医典',
        titleBar: {
          title: '中医医典',
          hasMenu: true
        }
      }
    }
    ]
  }
]

export default news
